module.exports = __webpack_public_path__ + "static/media/i-love-you-i-do.69736070.txt";